import _ from '@lodash';
import WorkflowItem from '../WorkflowItem';

export const defaultDefinition = {
	input_fields: [{ name: 'Components', type: 'Components', enabled: true, value: null }],
	output_fields: [{ name: 'Components', type: 'Variable' }],
	feature_column: null,
	component_title: null
};

export const converter = function (data) {
	return data;
};

export default function SumUpTransformation(props) {
	return <WorkflowItem {...props} type="SUM_UP" />;
}
